import {computed, ComputedRef, ref, Ref} from 'vue';
import {getMeInfo, serverTimeSyncsWithMine} from '@/base/me.js';
import {BackendError} from '@/base/callBackend.js';
import {renderFullDateLocal} from 'common';
import {ElLoading} from 'element-plus';

export enum LoadingState {
    LOADING          = 'loading',
    DONE             = 'done',
    TIME_ERROR       = 'time_error',
    GENERAL_ERROR    = 'general_error',
    PERMISSION_ERROR = 'permission_error'
}

export const loadingState: Ref<LoadingState>           = ref<LoadingState>(LoadingState.LOADING);
export const timeErrorMessage: Ref<string | undefined> = ref<string>();
export const done: ComputedRef<boolean>                = computed<boolean>(() => loadingState.value === LoadingState.DONE);

let loading: ReturnType<typeof ElLoading.service> | undefined;

const loadingSvg: string = `
  <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke="black"
      stroke-width="6"
      stroke-linecap="round"
      stroke-dasharray="100"
      stroke-dashoffset="0">
    </circle>
  </svg>`;

export async function reload() {
    try {
        loadingState.value      = LoadingState.LOADING;
        if (!await serverTimeSyncsWithMine()) {
            timeErrorMessage.value = await timeErrorInfo();
            loadingState.value     = LoadingState.TIME_ERROR;
        } else {
            loadingState.value      = LoadingState.DONE;
        }
    } catch (e) {
        loadingState.value = LoadingState.GENERAL_ERROR;
        if (e instanceof BackendError && e.details.reason=="PERMISSION") {
            loadingState.value = LoadingState.PERMISSION_ERROR;
        }
    }
}

async function timeErrorInfo(): Promise<string> {
    const me = await getMeInfo();
    if (!me) {
        return 'geen techinfo beschikbaar';
    }
    const serverTime = renderFullDateLocal(new Date(me.serverTimestamp));
    const localTime  = renderFullDateLocal(new Date(me.serverTimestamp + me.serverBehindLocalTime));
    const diff       = Math.abs(me.serverBehindLocalTime);
    return `device: ${localTime}<br>server: ${serverTime}<br>diff: ${diff} ms (incl network delay)`;
}

export function showHideLoading(show: boolean | undefined) {
    if (show) {
        if (loading === undefined) {
            loading = ElLoading.service({
                lock      : true,
                text      : 'Loading...',
                background: 'rgba(100, 100, 100, 0.5)',
                svg       : loadingSvg,
            });
        }
    } else {
        if (loading !== undefined) {
            loading.close();
            loading = undefined;
        }
    }
}
